module.exports = __webpack_public_path__ + "static/media/doctor-search_p3_3.4486190e.png";